import apiClient from "@/api/client";

let preferencesPromise = null;

export function getPreferences() {
  if (!preferencesPromise) {
    preferencesPromise = apiClient
      .get("/preferences")
      .then((response) => response.data)
      .finally(() => {
        preferencesPromise = null;
      });
  }

  return preferencesPromise;
}